import { QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevision_PartRevision_BoundingBoxFragment as BoundingBoxType } from '~/gql/graphql'
import Text from '~/core/Text'
import getColor from '~/lib/getColor'
import getDimensionsDisplayWithUnits, {
    UNITS_MM,
    UNITS_INCHES,
} from '~/lib/getDimensionsDisplayWithUnits'

export default function DimensionsDisplay(props: {
    boundingBox: BoundingBoxType | null
}) {
    return (
        <>
            <Text color={getColor('blackAlpha45')} fontSize="14px">
                {getDimensionsDisplayWithUnits(props.boundingBox, UNITS_MM)}
            </Text>
            <Text color={getColor('blackAlpha45')} fontSize="14px">
                {getDimensionsDisplayWithUnits(props.boundingBox, UNITS_INCHES)}
            </Text>
        </>
    )
}
